import { Link } from "react-router-dom";
import { MaskLines, Overline, FadeUp } from "@/components/motion";
import { useLang } from "@/context/LangContext";
import { useSite } from "@/context/SiteContext";

export const Schedule = () => {
  const { t, lang } = useLang();
  const { settings } = useSite();
  const SCHEDULE = (Array.isArray(settings?.schedule) ? settings.schedule : []).map((s) => [s.time, s.en, s.mh || s.en]);
  if (!SCHEDULE.length) return null;
  return (
    <section data-testid="schedule-section" className="mx-auto grid max-w-[1400px] gap-12 px-5 py-24 md:grid-cols-12 md:px-10">
      <div className="md:col-span-4">
        <Overline>{t("schedule.over")}</Overline>
        <MaskLines lines={[t("schedule.title")]} className="font-display mt-5 text-5xl font-semibold text-[#F4EEE2]" />
        {t("schedule.note") && <p className="mt-4 text-sm text-[#B7BFCC]">{t("schedule.note")}</p>}
      </div>
      <div className="md:col-span-8">
        {SCHEDULE.map(([time, en, mh], i) => (
          <FadeUp key={`${time}-${i}`} delay={i * 0.06} className="group flex items-baseline justify-between gap-6 border-b border-[#F4EEE2]/10 py-6 transition-colors hover:border-[#D4AF37]/50">
            <span data-ve-rec={`schedule|${i}|time`} className="font-mono text-sm text-[#D4AF37]">{time}</span>
            <span data-ve-rec={`schedule|${i}|@`} className="font-display flex-1 text-2xl text-[#F4EEE2] transition-transform duration-500 group-hover:translate-x-2 md:text-4xl">{lang === "mh" ? mh : en}</span>
          </FadeUp>
        ))}
      </div>
    </section>
  );
};

export const GiveCta = () => {
  const { t } = useLang();
  return (
    <section data-testid="give-cta-section" className="px-5 py-16 md:px-10">
      <div className="relative mx-auto max-w-[1400px] overflow-hidden rounded-[32px] bg-[#D4AF37] px-7 py-16 md:px-16 md:py-24">
        <div className="absolute -right-20 -top-20 h-80 w-80 rounded-full border-[40px] border-[#0B111E]/10" />
        <MaskLines lines={[t("give.title")]} className="font-display relative max-w-3xl text-5xl font-semibold leading-[1] text-[#0B111E] md:text-7xl" />
        <FadeUp className="relative mt-8 flex flex-wrap items-center gap-6">
          <p className="max-w-md text-base text-[#0B111E]/80">{t("give.text")}</p>
          <Link to="/donate" data-testid="give-cta-btn" className="rounded-full bg-[#0B111E] px-7 py-4 font-ui font-semibold text-[#F4EEE2] transition-transform duration-300 hover:-translate-y-0.5">
            {t("give.cta")}
          </Link>
        </FadeUp>
      </div>
    </section>
  );
};
